import { Modal, Button, message } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useState } from 'react';
import { createCheckoutSession } from 'services/api/users';
import { SESSION_PENDING_PRO_CHECKOUT } from 'utils/constants';
import { UPGRADE_REQUIRED_EVENT } from 'services/api/interceptors';

const UpgradePrompt = () => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUpgradeRequired = useCallback(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    window.addEventListener(UPGRADE_REQUIRED_EVENT, handleUpgradeRequired);
    return () => {
      window.removeEventListener(UPGRADE_REQUIRED_EVENT, handleUpgradeRequired);
    };
  }, [handleUpgradeRequired]);

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      const { data } = await createCheckoutSession();
      sessionStorage.setItem(SESSION_PENDING_PRO_CHECKOUT, '1');
      window.location.href = data.url;
    } catch (err) {
      message.error('Could not start checkout. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={
        <span>
          <RocketOutlined style={{ color: '#08a87f', marginRight: 8 }} />
          Upgrade to Pro
        </span>
      }
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="cancel" onClick={() => setVisible(false)}>
          Maybe Later
        </Button>,
        <Button
          key="upgrade"
          type="primary"
          loading={loading}
          onClick={handleUpgrade}
        >
          Upgrade Now
        </Button>,
      ]}
    >
      <p style={{ fontSize: 15, marginTop: 8 }}>
        This feature requires a Pro subscription. Upgrade to unlock unlimited
        access and premium features.
      </p>
    </Modal>
  );
};

export default UpgradePrompt;
